import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/forms_analytics_event.py
export const FORMS_ANALYTICS_ACTIONS = {
  // Form designer
  OPENED_FORM_DESIGNER: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'opened_form_designer',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_FORM_DESIGNER: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'submitted_form_designer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FIXED_INVALID_FORM_DEFINITION: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'fixed_invalid_form_definition',
    actionCategory: ACTION_CATEGORY.WRITE,
  },

  // Frontend (un)archiving
  CLICKED_FORM_ARCHIVE_BUTTON: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'clicked_form_archive_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_FORM_UNARCHIVE_BUTTON: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'clicked_form_unarchive_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },

  // Backend form definition
  CREATED_FORM_DEFINITION: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'created_form_definition',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_FORM_DEFINITION: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'updated_form_definition',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_FORM_DEFINITION: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'archived_form_definition',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNARCHIVED_FORM_DEFINITION: {
    module: ANALYTICS_MODULE.FORMS,
    action: 'unarchived_form_definition',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
